import builder from '../builder';
import OfficeFilePdf from '../../streamline-icons/light/office-file-pdf.svg';

export default builder('IconOfficeFilePdfLight', OfficeFilePdf);
